import React from 'react'
import PropTypes from 'prop-types'
import { TableCell, TableRow } from '../../../components/common/ResponsiveTable'
import { RouterLink } from '../../../components/common/Buttons'
import Typography from '../../../components/common/Typography'
import { Chip } from '../../../components/common/Chip'
import { useTrans } from '../../../services/i18n'

const ACTIVE_CHIP_STYLE = { backgroundColor: '#008e5b' }

const Item = ({ item }) => {
  const { trans } = useTrans()

  return (
    <TableRow>
      <TableCell align="left">
        <Typography
          to={`/organizations/${item.organizationId}`}
          weight="500"
          variant="h6"
          component={RouterLink}
        >
          {item.orgName}
        </Typography>
      </TableCell>

      <TableCell align="left">
        <Chip
          label={item.orgActive ? trans('active') : trans('deactivated')}
          color={item.orgActive ? 'success' : 'secondary'}
          style={item.orgActive ? ACTIVE_CHIP_STYLE : undefined}
        />
      </TableCell>

      <TableCell align="left">
        <Typography variant="inherit" fontFamily="lexend">
          {item.owner ? trans('owner') : item.role}
        </Typography>
      </TableCell>

      <TableCell align="left">
        <Typography variant="inherit" fontFamily="lexend">
          {item.ownerName}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

Item.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    organizationId: PropTypes.string,
    orgName: PropTypes.string,
    orgActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    owner: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    role: PropTypes.string,
    ownerName: PropTypes.string,
  }).isRequired,
}

export default Item
